import {observable, action} from 'mobx';

class HeaderStore {

  @observable isActiveSearch = false;
  @observable isFocusedSearch = false;
  @observable isScrolled = false;

  @action
  activateSearch = () => {
    this.isActiveSearch = !this.isActiveSearch;
    this.isFocusedSearch = !this.isFocusedSearch;
  };

  @action
  scrolled = () => {
    this.isScrolled = !this.isScrolled;
  };

  @action setSearchState = state => {
    this.isActiveSearch = state;
    this.isFocusedSearch = state;
  }
}

export default new HeaderStore();


// WEBPACK FOOTER //
// ./src/stores/headerStore.js